<lib-modal
  [closeLabel]="'general.close' | translate"
  data-testid="secret-dialog"
  [title]="'secretEncrypt.title' | translate"
  [contentTemplate]="body"
  [visible]="true"
  [disabled]="!canEncrypt()"
  [saveText]="(loading() ? 'secretEncrypt.encrypting' : 'secretEncrypt.encrypt') | translate"
  [cancelText]="'secretEncrypt.close' | translate"
  (save)="encrypt()"
  (cancel)="close()"
></lib-modal>

<ng-template #body>
  <div class="secret-dialog">
    <mat-form-field appearance="fill" floatLabel="always" class="tc-field tc-field--uppercase-label">
      <mat-label>{{ 'secretEncrypt.password' | translate }}</mat-label>
      <input
        matInput
        type="password"
        autocomplete="new-password"
        data-testid="secret-dialog-password"
        [attr.maxlength]="maxLength"
        [value]="password()"
        (input)="onPasswordInput($any($event.target).value)"
        (keydown.enter)="encrypt()"
      />
    </mat-form-field>

    <mat-form-field appearance="fill" floatLabel="always" class="tc-field tc-field--uppercase-label">
      <mat-label>{{ 'secretEncrypt.encrypted' | translate }}</mat-label>
      <input matInput readonly data-testid="secret-dialog-encrypted" [value]="encrypted()" />
    </mat-form-field>

    @if (loading()) {
      <div class="secret-dialog__loading" role="status" data-testid="secret-dialog-loading">
        <mat-spinner diameter="16" aria-hidden="true" />
        <span>{{ 'secretEncrypt.encrypting' | translate }}</span>
      </div>
    }
    @if (failed()) {
      <p class="secret-dialog__error" role="alert" data-testid="secret-dialog-error">
        {{ 'secretEncrypt.error' | translate }}
      </p>
    }

    <div class="secret-dialog__actions">
      <button
        mat-stroked-button
        type="button"
        data-testid="secret-dialog-copy"
        [disabled]="!encrypted()"
        (click)="copy()"
      >
        {{ 'secretEncrypt.copy' | translate }}
      </button>
      <button
        mat-stroked-button
        type="button"
        data-testid="secret-dialog-insert"
        [disabled]="!encrypted()"
        (click)="insert()"
      >
        {{ 'secretEncrypt.insert' | translate }}
      </button>
    </div>
  </div>
</ng-template>
